// extracted by mini-css-extract-plugin
export default {"divider":"ppS1qtTP5t7Btc+66BBxBQ=="};